import { ObjectValues } from '@tapestry/types';

export const URL_MESSAGE_ID = {
  user_not_registered: 'user_not_registered',
} as const;

export type UrlMessageId = ObjectValues<typeof URL_MESSAGE_ID>;
